import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-form5',
  templateUrl: './view-form5.component.html',
  styleUrls: ['./view-form5.component.css']
})
export class ViewForm5Component implements OnInit {
 title="Form-V: Application for new license/renewal of license to engage in the business of PSA";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/view-form5/view-form5.component.ts